export default __webpack_public_path__ + "assets/step_1.a3e908c3.svg";